import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface IAppHeaderTitleError {
    isActive: boolean;
    message?: string;
}

export interface IAppHeaderTitleLoading {
    isActive: boolean;
    message?: string;
}

@Injectable({ providedIn: 'root' })
export class AppHeaderTitleService {
    private readonly onHeaderTitleSubject: Subject<{ title: string; }> = new Subject();
    private readonly onErrorSubject: Subject<IAppHeaderTitleError> = new Subject();
    private readonly onLoadingSubject: Subject<IAppHeaderTitleLoading> = new Subject();

    public setHeaderTitle(title: string): void {
        this.onHeaderTitleSubject.next({ title });
    }

    public getHeaderTitle(): Observable<{ title: string; }> {
        return this.onHeaderTitleSubject.asObservable();
    }

    public setError(error: IAppHeaderTitleError): void {
        this.onErrorSubject.next(error);
    }

    public getError(): Observable<IAppHeaderTitleError> {
        return this.onErrorSubject.asObservable();
    }

    public setLoading(loading: IAppHeaderTitleLoading): void {
        this.onLoadingSubject.next(loading);
    }

    public getLoading(): Observable<IAppHeaderTitleLoading> {
        return this.onLoadingSubject.asObservable();
    }
}